import React from "react";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";

import { IMatch } from "apis";
import { parseTimestampIntoLocalDateTime } from "utils";
import vsImg from "assets/img/vs.png";

interface IMatchCardProps {
  match: IMatch;
}

export const MatchCard = ({ match }: IMatchCardProps) => {
  return (
    <Paper>
      <Box padding={4}>
        <Grid container>
          <Grid item xs={4} />
          <Grid item xs={4}>
            <Typography variant="h3" align="center" gutterBottom>
              {parseTimestampIntoLocalDateTime(match.startTime)}
            </Typography>
            <Typography variant="h3" align="center" gutterBottom>
              {match.address}
            </Typography>
          </Grid>
          <Grid item xs={4} />
        </Grid>
        <Grid container>
          <Grid item xs={4}>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="100%"
            >
              <Typography variant="h1">
                {match.homeFullTeam?.name || "-"}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box display="flex" justifyContent="center">
              <img src={vsImg} alt="" />
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="100%"
            >
              <Typography variant="h1" align="center" gutterBottom>
                {match.awayFullTeam?.name || "-"}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};
